export const productOptionSwatchStyles = {
  default: "default",
  dashed: "dashed",
};

export const productOptionSizes = {
  default: "default",
  small: "small",
};

export const imagePillOptionNames = ["direction", "orientation"];

export const isSwatchOption = ({ optionValues }) =>
  optionValues.some((optionValue) => optionValue.swatch);

export const isImagePillOption = ({ optionName, optionValues }) =>
  imagePillOptionNames.includes(optionName.trim().toLowerCase()) &&
  optionValues.some((optionValue) => optionValue.orientationImage);

export const unavailableStockStatuses = {
  waitlist: ["notifyMe", "notifyMeDate"],
  notInStock: [
    "outOfStock",
    "reserveNow",
    "reserveNowDate",
    "notifyMe",
    "notifyMeDate",
    "madeToOrder",
  ],
};
